





































import { Component, Vue } from "vue-property-decorator";
import { State, namespace } from "vuex-class";
import TPPClaimsModule from "@/store/modules/tpp-claims";
import { TPPClaimsState } from "@/models/store/TPPClaimsState";

const tppClaims = namespace(TPPClaimsModule.name);

@Component({
  name: "ClaimDisplay"
})
export default class ClaimDisplay extends Vue {
  // ===== Props ===== //

  // ===== Store ===== //
  @State("tppClaims") private readonly tppClaims!: TPPClaimsState;
  @tppClaims.Action("handleNewClaimStatus") public handleNewClaimStatus!: (payload: string) => void;
  @tppClaims.Action("handleTenantLocationCode") public handleTenantLocationCode!: (payload: string) => void;

  // ===== Data ===== //

  // ===== Methods ===== //

  // ===== Computed ===== //
  get facilities() {
    return this.$store.state.facility.facilitiesList;
  }

  get claimStatusesList() {
    return this.tppClaims.claimStatusesList;
  }

  get selectedTPPClaim() {
    return this.tppClaims.selectedTPPClaim;
  }

  get claimStatus() {
    return this.tppClaims.claimStatusUpdate && this.tppClaims.claimStatusUpdate.status.length
      ? this.tppClaims.claimStatusUpdate.status : this.selectedTPPClaim!.status;
  }
  set claimStatus(newVal: string) {
    this.handleNewClaimStatus(newVal);
  }

  get facilityLocationCode() {
    return this.selectedTPPClaim!.facility_location_code;
  }
  set facilityLocationCode(newVal: string) {
    this.handleTenantLocationCode(newVal);
  }

  // ===== Lifecycle ===== //
}
